import { render, staticRenderFns } from "./Genetics.vue?vue&type=template&id=6fd6d760&scoped=true&"
import script from "./Genetics.vue?vue&type=script&lang=js&"
export * from "./Genetics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd6d760",
  null
  
)

export default component.exports